import { SET_CUSTOM_FIELD_6 } from 'actions';

export function setCustomField6(sourceType: string) {
  return { sourceType, type: SET_CUSTOM_FIELD_6 };
}
